import React from "react";
import { Button } from "reactstrap";
import cx from "classnames";
import { Hammer } from "lucide-react";
export const FixNowButton = ({ id, className, ...props }) => (
  <Button outline className={cx("btn-icon", className)} size="sm" color="warning" href={`/cases/${id}/lab_fix`} {...props}>
    <Hammer />
  </Button>
);
